import React, { useMemo } from "react";
import { LuSnowflake, LuPackage, LuBriefcase } from "react-icons/lu";
import { ActionConfirmationContainer } from "../styled/common";

const STORAGE_LABELS = {
  0: "냉장",
  1: "상온",
  2: "캐리어",
};

const STORAGE_ICONS = {
  0: LuSnowflake,
  1: LuPackage,
  2: LuBriefcase,
};

const ActionConfirmation = ({
  transformValue = 0,
  title,
  explanation = [],
  storages = [],
  tel = "",
  onConfirm,
}) => {
  const groupedStorages = useMemo(() => {
    const grouped = {
      0: [],
      1: [],
      2: [],
    };

    storages.forEach((item) => {
      const type = Number(item.type);
      if (!grouped[type]) grouped[type] = [];
      grouped[type].push(item);
    });

    return grouped;
  }, [storages]);

  return (
    <ActionConfirmationContainer
      className="slideContent actionConfirmation"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="box">
        <div className="topBadge">보관 완료</div>

        <div className="tit">{title}</div>

        {storages.length > 0 && (
          <div className="storageGroups">
            {[0, 1, 2].map((type) => {
              const items = groupedStorages[type];
              if (!items || items.length === 0) return null;

              const Icon = STORAGE_ICONS[type] ?? LuPackage;

              return (
                <div className="storageGroup" key={type}>
                  <div className="groupHeader">
                    <span className={`icon iconType${type}`}>
                      <Icon />
                    </span>
                    <span className="label">{STORAGE_LABELS[type]} 보관함</span>
                  </div>

                  <div className="storageCards">
                    {items.map((item, idx) => (
                      <div className="storageCard" key={`${type}-${item.storageId}-${idx}`}>
                        <div className="cardNum">{item.storageId}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="con">
          {explanation.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
          {!!tel && <span className="tel">전화번호: {tel}</span>}
        </div>

        <div className="actions">
          <button onClick={onConfirm}>확인</button>
        </div>
      </div>
    </ActionConfirmationContainer>
  );
};

export default ActionConfirmation;